import React, { useState  } from 'react';
import { Button, Col, Row, RowProps  } from 'react-bootstrap';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type customBalanceRowProps = RowProps &
  React.PropsWithChildren<{
    balance: number;
    newCharges: number;
    balanceTotal: number;
    lastPayment: number;
    lastPaymentDate: string;
    outstandingBalance: number;
    approxRemainingPayments: string;
    reason: string;
  }>

const BalanceHistory = ({
    balance,
    newCharges,
    balanceTotal,
    lastPayment,
    lastPaymentDate,
    outstandingBalance,
    approxRemainingPayments,
    reason
}:customBalanceRowProps) => {
    const [showMore, setShowMore] = React.useState<boolean>(false);
  
    const toggleShowMore = (e: any) => {
      setShowMore(!showMore);
    };

    return (
    <>
        <Row 
            className={
              'striped-rows-fixed-children px-8 py-0 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
            }
          >
            <Col
              className={
                'd-flex d-lg-block align-items-center col-12 col-lg-1 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-end text-lg-center col'
              }
            >
              <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                Balance
              </h2>
              <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                ${balance}
              </span>
            </Col>
            <Col
              className={
                'd-flex d-lg-block align-items-center col-12 col-lg-1 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-end text-lg-center col'
              }
            >
              <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                New Charges
              </h2>
              <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                ${newCharges}
              </span>
            </Col>
            <Col
              className={
                'd-flex d-lg-block align-items-center col-12 col-lg-2 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-end text-lg-center col'
              }
            >
              <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                Balance Total
              </h2>
              <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                ${balanceTotal}
              </span>
            </Col>
            <Col
              className={
                'd-flex d-lg-block align-items-center col-12 col-lg-2 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-end text-lg-center col'
              }
            >
              <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                Last Payment Details
              </h2>
              <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                ${lastPayment}
                <br />
                <span className={'text-blue h3 text-fs-6 m-0'}>{lastPaymentDate}</span>
              </span>
            </Col>
            <Col
              className={
                'd-flex d-lg-block align-items-center col-12 col-lg-2 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-end text-lg-center col'
              }
            >
              <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                Outstanding Balance
              </h2>
              <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                ${outstandingBalance}
              </span>
            </Col>
            <Col
              className={
                'd-flex d-lg-block align-items-center col-12 col-lg-2 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-end text-lg-center col'
              }
            >
              <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                Approx Remaining Payments
              </h2>
              <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                {approxRemainingPayments}
              </span>
            </Col>
            <Col
              className={
                'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5 text-center'
              }
            >
              <div>
                <Button variant="primary" size="sm" onClick={toggleShowMore}>
                  {showMore ? 'Hide Reason' : 'View Reason'}
                </Button>
              </div>
            </Col>
          </Row>
          {showMore ? (
            <Row className="px-8 py-0 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info">
              <Col className="col-12 col-lg-12 py-6 px-5 mt-0 mt-lg-0 py-lg-0 text-start text-lg-start col">
                <div className="custom-blockquote primary default lh-xs container">
                  <b>Reason:</b> {reason}
                </div>
              </Col>
            </Row>
          ) : null}
    </>
  )
}

export default BalanceHistory